import { render, staticRenderFns } from "./InputRadioOld.vue?vue&type=template&id=f902d3a6&"
import script from "./InputRadioOld.vue?vue&type=script&lang=js&"
export * from "./InputRadioOld.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports